<template>
  <el-dialog
    ref="addEditDialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="h600_dialog abow_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('addEditDialog')"
  >
    <el-form
      ref="dialogAddEditViewForm"
      class="add-edit-view-form"
      @submit.native.prevent
    >
      <div class="modal-box">
        <h3 class="modal-title">
          基础信息
        </h3>
        <div class="modal-row-box">
          <el-tabs
            v-model="activeTab"
            class="set-permission-tabs"
            @tab-click="loadPermissionDatas"
          >
            <el-tab-pane
              v-for="(moduleOne) in activeTabData"
              :key="moduleOne.data"
              :label="moduleOne.label"
              :name="moduleOne.data + ''"
              :lazy="true"
            >
              <div>
                {{ moduleOne.label }}
                <div>
                  <el-radio-group
                    v-model="allRadios"
                    @change="((label)=>{handelRadioChecked(label, moduleOne)})"
                  >
                    <el-radio-button :label="1">
                      全选
                    </el-radio-button>
                    <el-radio-button :label="2">
                      反选
                    </el-radio-button>
                    <el-radio-button :label="3">
                      恢复
                    </el-radio-button>
                  </el-radio-group>
                </div>
                <div
                  v-for="(resource) in modules"
                  :key="resource.data"
                  class="permission-item"
                >
                  <span class="permission-name">{{ resource.label }}</span>
                  <el-checkbox-group v-model="checkedDatas[moduleOne.data]">
                    <el-checkbox
                      v-for="(actionCheckbox) in actions[resource.data]"
                      :key="actionCheckbox.id"
                      :label="actionCheckbox.id"
                    >
                      {{ actionCheckbox.name }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        type="primary"
        @click="handleSave"
      >
        保存
      </el-button>
      <el-button @click="modalClose">
        取消
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
import { loadPermissionListApi, loadPermissionActionMapApi, saveRolePermissionApi } from '@/api/role'
export default {
  components: {  },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
   return{
      activeTab: '',
      activeTabData: [],
      modules: [],
      initCheckeds: {},
      checkedDatas: {},
      checkedAll: {},
      actions: [],
      allRadios: null,
   }
  },

  watch: {
    dialogVisible (val) {
      if (val) {   
        this.activeTab = ''
        this.modules = []
        this.initCheckeds = {}
        this.checkedDatas = {}
        this.checkedAll = {}
        this.actions = []
        this.allRadios = null
        this.initGradeOneModuleData()  
      }
    }
  },
  methods: { 
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.activeTab = ''
      this.modules = []
      this.actions = []
      this.initCheckeds = {}
      this.checkedDatas = {}
      this.checkedAll = {}
      this.allRadios = null
      this.selectModuleId = null
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 初始加载第一级模块权限
    initGradeOneModuleData () {
      this.activeTabData = []
      loadPermissionListApi({nodeLevel: 1}).then(res => {
        let resData = res.data ? res.data : []
        resData.forEach(element => {
          this.activeTabData.push({data: element.id, label: element.name})
        });
      })
    },
    // 加载tab选项卡
    loadPermissionDatas(tab){
      this.selectModuleId = tab.name
      loadPermissionActionMapApi({moduleId: tab.name, roleId: this.dataId}).then(res => {
        const { data } = res
        this.initCheckeds = data.initCheckeds
        this.checkedDatas = data.checkedDatas
        this.checkedAll = data.checkedAll
        this.modules = data.modules
        this.actions = data.actions
        this.allRadios = data.allRadios
      })
    },
    // 保存角色管理操作权限方法
    handleSave () {
      let checkedActions = ''
      this.checkedDatas[this.selectModuleId].forEach(checkedAction => {
        checkedActions += ',' + checkedAction
      })
      if (checkedActions.length > 0) checkedActions = checkedActions.slice(1)
      let params = { roleId: this.dataId, actionIds: checkedActions, moduleId: this.selectModuleId }
      this.$confirm(
            '是否确定保存','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              saveRolePermissionApi(params).then(res => {
                if (res.mark === '200') {
                  this.$message({
                    message: res.message,
                    type: 'success'
                  })
                  this.modalClose()
                }
              })
            })
            .catch(() => { })
    },
    // 【全选|反选|恢复】单选项选中后的处理
    handelRadioChecked (value, module) {
      if (value === 1) {
        this.checkedDatas[module.data] = this.checkedAll[module.data]
      } else if (value === 2) {
        let moduleAllActions = new Set(this.checkedAll[module.data])
        let moduleCheckedActions = new Set(this.checkedDatas[module.data])
        let difference = new Set([...moduleAllActions].filter(x => !moduleCheckedActions.has(x)))
        this.checkedDatas[module.data] = [...difference]
      } else if (value === 3) {
        this.checkedDatas[module.data] = this.initCheckeds[module.data]
      }
      this.allRadios = value
    }
  }
}
</script>
<style lang="scss"  scoped>
.permission-item{
  display: flex;
  flex: 0 260px;
}
.el-checkbox-group{
  flex: 1;
}
</style>
